module.exports = __webpack_public_path__ + "img/14.293c4acc.jpg";